import React from 'react';
import { useParams } from 'react-router-dom';

import ListModelNavigation from '@dashboard/components/ListModelNavigation';
import { useWorkflowRunsListHref } from '@dashboard/hooks/route/hrefs';

export default function Navigation() {
  const id = useParams<{ id: string }>().id!;
  const getLinkHref = (id: string) => `../workflow-runs/${id}`;
  const backLinkHref = useWorkflowRunsListHref();
  return <ListModelNavigation currentModelId={id} backLinkHref={backLinkHref} getLinkHref={getLinkHref} />;
}
